<template ref="keyText">
  <span ref="keyText" style=" white-space: pre;"><slot></slot></span>
</template>
<script>
import unitTexts from "@/wl-unit-text/UnitTexts";
import useUnitText from "@/wl-unit-text/useUnitText";
import {mapGetters} from "vuex";

export default {
  name: "WnlText",
  props:{capitalise:Boolean},
  data: () => ({
    keywords: unitTexts
  }),
  computed:{
    ...mapGetters([
        'userDetails'
    ])
  },
  mounted() {
    let text = this.$refs.keyText;
    text.innerText = this.replaceText(text.innerHTML, this.userDetails.UnitType)
  },
  methods: {
    replaceText(text, type) {
      return useUnitText().replaceText(text, type)
    }
  }
}
</script>

<style scoped>

</style>